module.exports = __webpack_public_path__ + "static/media/OrchidMalevolence.8025e2e4.png";